import { observer } from 'mobx-react';
import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import EditTrappingZoneMap from '../maps/EditTrappingZoneMap';
import { useStores } from '../stores/useStores';

function EditTrappingZoneForm({
  handleSubmit,
  handleChange,
  handleBlur,
  values,
  errors,
  setFieldValue,
  boundary,
  setBoundary,
  id,
  map,
  customOptions
}) {
  const { traplogStore } = useStores();

  const formOptions = customOptions?.form;
  const nameOptions = formOptions?.name;

  return (
    <Form noValidate onSubmit={handleSubmit}>
      {/* Name */}
      <Form.Group controlId='name'>
        <Form.Label>
          {nameOptions?.label ? nameOptions?.label : 'Name'}
        </Form.Label>
        <Form.Control
          type='text'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.name}
          placeholder={
            nameOptions?.placeholder ? nameOptions?.placeholder : 'Name'
          }
          isInvalid={errors.name}
          maxLength={nameOptions?.maxLength}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.name}
        </Form.Control.Feedback>
      </Form.Group>

      {/* Mating Disruption Tie */}
      <Form.Group controlId='mating_disruption_tie_id'>
        <Form.Label>Mating Disruption Tie</Form.Label>
        <Select
          options={traplogStore.matingDisruptionTies.map(
            (matingDisruptionTie) => {
              return {
                value: matingDisruptionTie.id,
                label: matingDisruptionTie.name
              };
            }
          )}
          defaultValue={values.matingDisruptionTie}
          onChange={(option) => setFieldValue('matingDisruptionTie', option)}
          isClearable
        />
        {errors.matingDisruptionTie ? (
          <div className='text-danger'>{errors.matingDisruptionTie}</div>
        ) : null}
      </Form.Group>
      {/* High Risk Production Site */}
      <Form.Group controlId='high_risk'>
        <Form.Check
          custom
          disabled={!values.cmsm}
          type='checkbox'
          id='high_risk'
          label='High Risk Production Site?'
          checked={values.high_risk}
          onChange={() => {
            if (!values.cmsm) return;
            setFieldValue('high_risk', Number(!values.high_risk));
          }}
          defaultChecked={values.high_risk}
          style={{ zIndex: 0 }}
        />
      </Form.Group>
      {/* Codling Moth Sensitive Market */}
      <Form.Group controlId='cmsm'>
        <Form.Check
          custom
          type='checkbox'
          id='cmsm'
          label='Codling Moth Sensitive Market?'
          checked={values.cmsm}
          onChange={() => {
            if (values.cmsm) setFieldValue('high_risk', false);
            setFieldValue('cmsm', !values.cmsm);
          }}
          defaultChecked={values.cmsm}
          style={{ zIndex: 0 }}
        />
      </Form.Group>
      {map && (
        <Row style={{ height: '300px' }}>
          <Col>
            <EditTrappingZoneMap
              boundary={boundary}
              setBoundary={setBoundary}
              id={id}
            />
          </Col>
        </Row>
      )}
      <Button varient='primary' type='submit'>
        Submit
      </Button>
    </Form>
  );
}

export default observer(EditTrappingZoneForm);
